import { render, staticRenderFns } from "./KitchensPage.vue?vue&type=template&id=02b6e1a8&scoped=true&"
import script from "./KitchensPage.vue?vue&type=script&lang=js&"
export * from "./KitchensPage.vue?vue&type=script&lang=js&"
import style0 from "./KitchensPage.vue?vue&type=style&index=0&id=02b6e1a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b6e1a8",
  null
  
)

export default component.exports